import { combineReducers } from '@reduxjs/toolkit';
import { reducer as calendarReducer } from 'slices/calendar';
import { reducer as mailboxReducer } from 'slices/mailbox';
import { reducer as projectsBoardReducer } from 'slices/projects_board';
import filesReducer from 'store/ducks/Files';
import parametersReducer from 'store/ducks/Parameters';
import signinReducer from 'store/ducks/Signin';

const rootReducer = combineReducers({
  calendar: calendarReducer,
  projectsBoard: projectsBoardReducer,
  mailbox: mailboxReducer,
  parameters: parametersReducer,
  files: filesReducer,
  signin: signinReducer,
});

export default rootReducer;
